import { useState, type ReactNode } from 'react'
import { DateSelectionContext } from './DateSelectionContext'

interface DateSelectionProviderProps {
  children: ReactNode
  /** Pre-selected range, used when re-opening the calendar over an existing selection. */
  initialFrom?: Date | null
  initialTo?: Date | null
}

export function DateSelectionProvider({ children, initialFrom = null, initialTo = null }: DateSelectionProviderProps) {
  const [selectedFrom, setSelectedFrom] = useState<Date | null>(initialFrom)
  const [selectedTo, setSelectedTo] = useState<Date | null>(initialTo)

  return (
    <DateSelectionContext.Provider value={{ selectedFrom, selectedTo, setSelectedFrom, setSelectedTo }}>
      {children}
    </DateSelectionContext.Provider>
  )
}
